export const searchPacks = (searchTerm, includeContent, contentType) => {
    return new Promise((resolve) => {
        fetch('/packSearch/' , {
            method: 'POST',
            body: JSON.stringify({searchTerm, includeContent, contentType}),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
            .then(resp => resp.json())
            .then(resp => {
                resolve(resp);
            });
    });
};
